import { __makeTemplateObject } from "tslib";
import { Title } from "../../../../components/Panel";
import styled from "../../styled-components";
export var CallbackTitle = styled(Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: ", ";\n  margin: 0 4px;\n  vertical-align: middle;\n"], ["\n  text-decoration: ", ";\n  margin: 0 4px;\n  vertical-align: middle;\n"])), function (e) {
  return e.deprecated ? "line-through" : "none";
});
var templateObject_1;